// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ByteOrder } from "./byte-order";
import { FieldKind } from "./field-kind";
import { Narrow } from "./narrow";

/**
 * One field of a record layout. A zero `count` is a scalar field.
 */
export class FieldDecode implements flatbuffers.IUnpackableObject<FieldDecodeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FieldDecode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFieldDecode(bb: flatbuffers.ByteBuffer, obj?: FieldDecode): FieldDecode {
    return (obj || new FieldDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFieldDecode(
    bb: flatbuffers.ByteBuffer,
    obj?: FieldDecode,
  ): FieldDecode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FieldDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  offset(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  width(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  count(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  kind(): FieldKind {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FieldKind.Unsigned;
  }

  narrow(): Narrow {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Narrow.None;
  }

  /**
   * This field's byte order where it differs from the record's. Null in a
   * profile means the record's order; a table always carries it.
   */
  byteOrder(): ByteOrder | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  static startFieldDecode(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addOffset(builder: flatbuffers.Builder, offset: number) {
    builder.addFieldInt32(1, offset, 0);
  }

  static addWidth(builder: flatbuffers.Builder, width: number) {
    builder.addFieldInt8(2, width, 0);
  }

  static addCount(builder: flatbuffers.Builder, count: number) {
    builder.addFieldInt16(3, count, 0);
  }

  static addKind(builder: flatbuffers.Builder, kind: FieldKind) {
    builder.addFieldInt8(4, kind, FieldKind.Unsigned);
  }

  static addNarrow(builder: flatbuffers.Builder, narrow: Narrow) {
    builder.addFieldInt8(5, narrow, Narrow.None);
  }

  static addByteOrder(builder: flatbuffers.Builder, byteOrder: ByteOrder) {
    builder.addFieldInt8(6, byteOrder, null);
  }

  static endFieldDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // name
    return offset;
  }

  static createFieldDecode(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    offset: number,
    width: number,
    count: number,
    kind: FieldKind,
    narrow: Narrow,
    byteOrder: ByteOrder | null,
  ): flatbuffers.Offset {
    FieldDecode.startFieldDecode(builder);
    FieldDecode.addName(builder, nameOffset);
    FieldDecode.addOffset(builder, offset);
    FieldDecode.addWidth(builder, width);
    FieldDecode.addCount(builder, count);
    FieldDecode.addKind(builder, kind);
    FieldDecode.addNarrow(builder, narrow);
    if (byteOrder !== null) FieldDecode.addByteOrder(builder, byteOrder);
    return FieldDecode.endFieldDecode(builder);
  }

  unpack(): FieldDecodeT {
    return new FieldDecodeT(
      this.name(),
      this.offset(),
      this.width(),
      this.count(),
      this.kind(),
      this.narrow(),
      this.byteOrder(),
    );
  }

  unpackTo(_o: FieldDecodeT): void {
    _o.name = this.name();
    _o.offset = this.offset();
    _o.width = this.width();
    _o.count = this.count();
    _o.kind = this.kind();
    _o.narrow = this.narrow();
    _o.byteOrder = this.byteOrder();
  }

  unpackFields(...fields: string[]): FieldDecodeT {
    const t = new FieldDecodeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("offset")) {
      t.offset = this.offset();
    }
    if (fieldSet.has("width")) {
      t.width = this.width();
    }
    if (fieldSet.has("count")) {
      t.count = this.count();
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("narrow")) {
      t.narrow = this.narrow();
    }
    if (fieldSet.has("byte_order")) {
      t.byteOrder = this.byteOrder();
    }
    return t;
  }
}

export class FieldDecodeT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public offset: number = 0,
    public width: number = 0,
    public count: number = 0,
    public kind: FieldKind = FieldKind.Unsigned,
    public narrow: Narrow = Narrow.None,
    public byteOrder: ByteOrder | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;

    return FieldDecode.createFieldDecode(
      builder,
      name,
      this.offset,
      this.width,
      this.count,
      this.kind,
      this.narrow,
      this.byteOrder,
    );
  }

  clone(): FieldDecodeT {
    const obj = new FieldDecodeT();
    obj.name = this.name;
    obj.offset = this.offset;
    obj.width = this.width;
    obj.count = this.count;
    obj.kind = this.kind;
    obj.narrow = this.narrow;
    obj.byteOrder = this.byteOrder;
    return obj;
  }

  equals(other: FieldDecodeT): boolean {
    if (this.name !== other.name) return false;
    if (this.offset !== other.offset) return false;
    if (this.width !== other.width) return false;
    if (this.count !== other.count) return false;
    if (this.kind !== other.kind) return false;
    if (this.narrow !== other.narrow) return false;
    if (this.byteOrder !== other.byteOrder) return false;
    return true;
  }
}

export function verifyFieldDecode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "name");
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
  } finally {
    verifier.popDepth();
  }
}
